import { render, staticRenderFns } from "./FeaturesList.vue?vue&type=template&id=6b9ee33a"
import script from "./FeaturesList.js?vue&type=script&lang=js&external"
export * from "./FeaturesList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports